<div
  v-if="shouldRenderConfig && getIsProductPersonalizationFullPageConfiguration"
  v-bind:class="getClassName + 'Container'"
>
  <button type="button" :class="getClassName" class="btn btn-primary">
    <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/create_artwork.png'"/>
    {{ $t('Create Artwork with YLP Studio') }}
  </button>
</div>
